export default function Notes() {
    return (
        <div className="notes-page-content">
            <h1>Notes</h1>
        </div>
    );
}